import {
	KColorSwatchPicker,
	KForm,
	KTextField
} from "kinnect-general";

export default KForm.extend( {
	name: "KServiceTypeForm",

	props: {
		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "serviceTypes" } ]
		},

		serviceType: Object
	},

	data: () => ( {
		formFields: {
			name: null,
			color: null
		},
		users: null
	} ),

	computed: {
		editing() {
			return Boolean( this.serviceType );
		},

		formUrl() {
			return this.editing ? `service-types/${this.serviceType.id}` : "service-types";
		}
	},

	watch: {
		serviceType: {
			handler( serviceType ) {
				if ( serviceType ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( serviceType.hasOwnProperty( key ) ) {
							this.formFields[key] = serviceType[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<KTextField
				label="Status Type Name*"
				required
				vModel={this.formFields.name}
				validationName="name"
				validationRules="required"
			></KTextField>

			<KColorSwatchPicker
				label="Associated Color*"
				required
				vModel={this.formFields.color}
				validationName="color"
				validationRules="required"
			></KColorSwatchPicker>
		</KForm>;
	}
} );
